var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", _vm._g({ staticClass: "searchTag" }, _vm.$listeners), [
    _vm._v(_vm._s(_vm.label))
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }